export { default } from './main-page';
